<div id="sign-in-form-container" class="cyber-form">
  <form
    id="login"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    aria-describedby="server-error"
  >
    <label for="sn-email" class="visually-hidden">Email</label>
    <input title="Form input"
      id="sn-email"
      class="form-control"
      formControlName="email"
      type="email"
      placeholder="Email"
      autocomplete="email"
      aria-required="true"
    />

    @if (email && email.invalid && email.dirty) {
      <div class="text-danger small" role="status">
        You must enter a valid email address
      </div>
    }

    <label for="sn-password" class="visually-hidden">Password</label>
    <div class="form-group" [ngClass]="{ accent: email && email.valid }">
      <input title="Form input"
        id="sn-password"
        class="form-control"
        formControlName="password"
        type="password"
        placeholder="Password"
        autocomplete="current-password"
        aria-required="true"
      />
    </div>

    <div id="server-error" class="server-error" aria-live="polite">
      {{ serverMessage }}
    </div>

    <div class="form-group">
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="form.invalid || loading"
      >
        Login
      </button>
    </div>

    <!-- reCAPTCHA Badge Notice -->
    <div class="recaptcha-notice">
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" target="_blank"
        >Privacy Policy</a
      >
      and
      <a href="https://policies.google.com/terms" target="_blank"
        >Terms of Service</a
      >
      apply.
    </div>

    <div class="form-actions">
      <a
        class="btn btn-secondary"
        [routerLink]="['/register/quick']"
        routerLinkActive="active"
      >
        Register
      </a>

      <a
        class="btn btn-ghost"
        [routerLink]="['/reset-password']"
        routerLinkActive="active"
      >
        Forgot password?
      </a>
    </div>
  </form>
</div>
